// extracted by mini-css-extract-plugin
export default {"container":"ClassEnrollmentBody_container__79O-6","enrollDateString":"ClassEnrollmentBody_enrollDateString__6YAgQ"};